import Main from '@/pages/framework/main.vue'

let routes = [{
	path: '/',
	component: Main,
	children: [{
		path: 'warehouse/boxmai',
		meta: {
			auth: true,
			code: 'WAREHOURSE_MGR_BOXMAI_LIST'
		},
		component: resolve => require(['@/pages/warehouse/boxmai.vue'], resolve),
		name: 'warehouse 箱唛列表'
	},{
		path: 'warehouse/report/boxmai',
		meta: {
			auth: true,
			code: 'WAREHOURSE_REPORT_BOXMAI_LIST'
		},
		component: resolve => require(['@/pages/warehouse/report/boxmai.vue'], resolve),
		name: 'warehouse 箱唛报表'
	},{
		path: 'warehouse/report/season',
		meta: {
			auth: true,
			code: 'WAREHOURSE_REPORT_SEASON_LIST'
		},
		component: resolve => require(['@/pages/warehouse/report/season.vue'], resolve),
		name: 'warehouse SEASON报表'
	},{
		path: 'warehouse/import/pa',
		meta: {
			auth: true,
			code: 'SP_WAREHOURSE_IMPORT_PA'
		},
		component: resolve => require(['@/pages/warehouse/import-pa.vue'], resolve),
		name: 'warehouse 导入PA'
	}, {
		path: 'warehouse/import/mc',
		meta: {
			auth: true,
			code: 'SP_WAREHOURSE_IMPORT_MC'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/boxmai/import-mc.vue'], resolve),
		name: 'warehouse 导入MC'
	}, {
		path: 'warehouse/pa/config',
		meta: {
			auth: true,
			code: 'SP_WAREHOURSE_PA_CONFIG'
		},
		component: resolve => require(['@/pages/warehouse/pa-config.vue'], resolve),
		name: 'warehouse PA配置'
	}]
}];

export default routes;


// WEBPACK FOOTER //
// ./src/config/routes/warehouse.js